export const isAlphaNumeric = (value: string): boolean =>
  new RegExp(/^[a-zA-Z0-9]+$/gm).test(value);
export const isAlphaNumericPlus = (value: string): boolean =>
  new RegExp(/^[a-zA-Z0-9.`@+_-]+$/gm).test(value);

export const orderByAlphabetical = (
  a: string,
  b: string,
  allToLower: boolean = false
): number => {
  const aValue = allToLower ? a.toLowerCase() : a;
  const bValue = allToLower ? b.toLowerCase() : b;
  if (aValue < bValue) {
    return -1;
  }
  if (aValue > bValue) {
    return 1;
  }
  return 0;
};
